import { useParams } from "react-router";

const useGetParams = (param: string) => {
  const { [param]: paramValue } = useParams();
  return parseInt(`${paramValue ?? ""}`, 10);
};

export default useGetParams;
